import { getRegion } from './locale'
import { getQueryObj } from './query'

// 环境区分
export const inBrowser = typeof window !== 'undefined'
export const UA = inBrowser && window.navigator.userAgent.toLowerCase()
export const isIE = UA && /msie|trident/.test(UA)
export const isIE9 = UA && UA.indexOf('msie 9.0') > 0
export const isEdge = UA && UA.indexOf('edge/') > 0
export const inMerchantPAD = UA && /soda\.PADMerchant/i.test(UA)
export const isAndroid = UA && /android/i.test(UA)
export const isIOS = UA && /iphone|ipad|ipod|ios/i.test(UA)
export const isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge
export const inNative = UA && /FusionKit/i.test(UA)
export const inMerchantPC = UA && /soda\.PCMerchant/i.test(UA) // exe环境
// BDApp 新版UA: 'BDApp FlutterWebView'
export const isBDApp = UA.includes('soda.manager') || UA.includes('bdapp')
export const isNativeBDApp = UA.includes('soda.manager') && !UA.includes('bdapp')
export const isFlutterBDApp = UA.includes('bdapp')
export const isBApp = UA.includes('soda.merchant')

export const isProduction = process.env.NODE_ENV === 'production'
export const isDev = process.env.NODE_ENV === 'development'
export const isSim = location.host.startsWith('sim')
export const isPre =
  location.host.includes('pre-b-h5.didi-food.com') ||
  location.host.includes('pre-food-b-h5.99app.com')
export const isOnline =
  (location.host.includes('didi-food') || location.host.includes('food-b-h5.99app.com')) && !isPre
// debug 环境，非线上，本地或者地址栏参数中带着 foodDebug 字段
export const isDebug = !isOnline && (isDev || location.search.includes('foodDebug'))

// 是否来自 BDAPP 跳转（基于 URL 参数判断）
export const isFromBDAPP = !!Number(getQueryObj()?.fromBDAPP || 0)

// 国家区分

// is99只用于设置主题，其他业务判断那请用store里的isBr
export const is99 = location.host.includes('food-b-h5.99app.com') || getRegion() === 'BR'

export const isManagerHome =
  location.pathname.endsWith('/manager') || location.pathname.endsWith('/manager/')
